import React from 'react';
import { ResultCard, PromoCard } from './index';

function Results({ setIsShowAdjustedModal, data = [] }) {
    const occasions = data.filter(({ type }) => type === 'occasion');

    return (
        <ul className="op-results">
            {occasions.length !== 0 &&
                data.map(({ type, data, url }, index) => {
                    if ('occasion' === type) {
                        return (
                            <li className="op-result--item" key={index}>
                                <ResultCard
                                    setIsShowAdjustedModal={setIsShowAdjustedModal}
                                    index={index}
                                    result={data}
                                    url={url}
                                />
                            </li>
                        );
                    } else if ('promo' === type && 'no-results' !== data.show) {
                        return (
                            <li className="op-promo--item" key={index}>
                                <PromoCard index={index} result={data} />
                            </li>
                        );
                    } else {
                        return null;
                    }
                })}

            {occasions.length === 0 &&
                data.map(({ type, data }, index) => {
                    if ('promo' === type && 'has-results' !== data.show) {
                        return (
                            <li key={index}>
                                <PromoCard index={index} result={data} />
                            </li>
                        );
                    } else {
                        return null;
                    }
                })}
        </ul>
    );
}

export default Results;
